import { IUserSessionsRepository } from 'modules/authentication/domain/repositories';
import { UseCaseError } from 'shared/domain/errors';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import IOAuthProvider, {
  ISocialUser,
} from 'shared/domain/providers/IOAuthProvider';
import IStorageProvider from 'shared/domain/providers/IStorageProvider';

export default class PerformSocialLoginUseCase {
  private pendingSocialUser: ISocialUser | null = null;

  constructor(
    private oAuthProvider: IOAuthProvider,
    private storageProvider: IStorageProvider,
    private httpProvider: IHTTPProvider,
    private userSessionsRepository: IUserSessionsRepository,
  ) {}

  public async execute(phone?: string) {
    if (!this.pendingSocialUser) {
      const socialUser = await this.oAuthProvider.getSocialUser();

      if (!socialUser) throw new UseCaseError('Could not retrieve social user');

      this.pendingSocialUser = socialUser;
    }

    const { auth, session } = await this.userSessionsRepository.create({
      type: 'SOCIAL',
      token: this.pendingSocialUser.token,
      phone: phone ?? this.pendingSocialUser.phone,
    });

    this.pendingSocialUser = null;

    this.storageProvider.store('AUTHENTICATION', { auth, session });

    this.httpProvider.setHeader('AUTHENTICATION', `Bearer ${auth.accessToken}`);

    return session;
  }
}
